import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import 'rxjs/add/operator/toPromise';
import {User} from '../../../classes/user';
import {Dog} from "../../../classes/dog";
import config from '../../../config';
import {generatePassword} from "../../admin/utils/passwordGenerator";
import {kanAuthService} from "./auth";
import {kanLoadingService} from "./loading";


@Injectable()
export class kanUsersService {
    constructor(private http: HttpClient,
                private authService: kanAuthService,
                private loadingService: kanLoadingService) {
    }

    get user(): User {
        return this.authService.user;
    }

    get role(): string {
        return this.authService.role;
    }

    isAuthenticated(): boolean {
        return !!this.authService.token;
    }

    public login(identity): Promise<User> {
        this.authService.remember = identity.remember;
        return new Promise((resolve, reject) => {
            this.http.post(
                `${config.apiRootUrl}/api/users/login`,
                {
                    email: identity.email,
                    password: identity.password,
                    remember: identity.remember
                })
                .toPromise()
                .then((response: any) => {
                    let data = response.data;
                    this.authService.token = data.token.accessToken;
                    this.authService.refreshToken = data.token.refreshToken;
                    this.authService.user = data.user as User;
                    resolve(this.authService.user);
                })
                .catch((error: any) => {
                    reject(error);
                });
        });
    }

    public logout(): void {
        this.authService.clear();
    }

    public getUsers(filter: any = {}): Promise<User[]> {
        return new Promise((resolve, reject) => {
            let params = new HttpParams().set('filter', JSON.stringify(filter));
            this.http.get(`${config.apiRootUrl}/api/users`, {params: params})
                .toPromise()
                .then((respone: any) => {
                    resolve(respone as User[]);
                })
                .catch((error: any) => {
                    reject(error);
                });
        });
    }

    public countUsers(filter: any = {}): Promise<number> {
        return new Promise((resolve, reject) => {
            let params = new HttpParams().set('where', JSON.stringify(filter));
            this.http.get(`${config.apiRootUrl}/api/users/count`, {params: params})
                .toPromise()
                .then((respone: any) => {
                    resolve(respone.count as number);
                })
                .catch((error: any) => {
                    reject(error);
                });
        });
    }

    public getUserById(id: string): Promise<User> {
        return new Promise((resolve, reject) => {
            this.http.get(`${config.apiRootUrl}/api/users/${id}`)
                .toPromise()
                .then((respone: any) => {
                    resolve(respone as User);
                })
                .catch((error: any) => {
                    reject(error);
                });
        });
    }

    public addUser(user: User): Promise<any> {
        this.loadingService.show();
        user = this.cleanUser(user);
        return new Promise((resolve, reject) => {
            if (!user.password) {
                user.password = generatePassword();
            }
            this.http.post(`${config.apiRootUrl}/api/users`, user)
                .toPromise()
                .then((respone) => {
                    this.loadingService.hide();
                    resolve(respone as User);
                })
                .catch((error: any) => {
                    this.loadingService.hide();
                    reject(error);
                });
        });
    }

    public updateUser(user: User): Promise<any> {
        this.loadingService.show();
        user = this.cleanUser(user);
        return new Promise((resolve, reject) => {
            this.http.patch(`${config.apiRootUrl}/api/users/${user.id}`, user)
                .toPromise()
                .then((respone) => {
                    this.loadingService.hide();
                    resolve(respone as User);
                })
                .catch((error: any) => {
                    this.loadingService.hide();
                    reject(error);
                });
        });
    }

    public removeUser(user: User): Promise<any> {
        this.loadingService.show();
        return new Promise((resolve, reject) => {
            this.http.post(`${config.apiRootUrl}/api/users/${user.id}/deactivate`, {})
                .toPromise()
                .then((respone) => {
                    this.loadingService.hide();
                    resolve(respone as User);
                })
                .catch((error: any) => {
                    this.loadingService.hide();
                    reject(error);
                });
        });
    }

    public isEmailUsed(email: string): Promise<boolean> {
        return new Promise((resolve, reject) => {
            this.http.post(`${config.apiRootUrl}/api/users/usedemail`, {email: email})
                .toPromise()
                .then((respone: any) => {
                    resolve(respone.data as boolean);
                })
                .catch((error: any) => {
                    reject(error);
                });
        });
    }

    public getDogs(id: string): Promise<Dog[]> {
        return new Promise((resolve, reject) => {
            let filter = {
                where: {
                    active: true
                }
            };
            let params = new HttpParams().set('filter', JSON.stringify(filter));
            this.http.get(`${config.apiRootUrl}/api/users/${id}/dogs`, {params: params})
                .toPromise()
                .then((respone: any) => {
                    let dogs = respone.map((item) => {
                        item.birthday = item.birthday ? new Date(item.birthday) : null;
                        item.membershipDate = item.membershipDate ? new Date(item.membershipDate) : null;
                        item.membershipRenewalDate = item.membershipRenewalDate ? new Date(item.membershipRenewalDate) : null;
                        return item;
                    });
                    resolve(dogs as Dog[]);
                })
                .catch((error: any) => {
                    reject(error);
                });
        });
    }

    private cleanUser(user: User): User {
        Object.keys(user).forEach((key) => {
            if (user[key] === '') {
                user[key] = null;
            }
        });
        return user;
    }
}



// WEBPACK FOOTER //
// ./src/modules/services/services/users.ts